import React from 'react';
import { Box, Typography, SxProps, Theme } from '@mui/material';
import { ChevronLeft } from '@mui/icons-material';

export const BackButton: React.FC<{ onClick: () => void; sx?: SxProps<Theme> }> = ({ onClick, sx }) => (
  <Box
    onClick={onClick}
    sx={{
      display: 'inline-flex',
      alignItems: 'center',
      mt: 2,
      mb: 2,
      color: '#007AFF',
      cursor: 'pointer',
      userSelect: 'none',
      gap: '2px',
      '&:active': { opacity: 0.6 },
      ...sx,
    }}
  >
    <ChevronLeft sx={{ fontSize: 18 }} />
    <Typography
      sx={{
        fontSize: 14,
        fontWeight: 600,
        lineHeight: 1,
      }}
    >
      Назад
    </Typography>
  </Box>
);
